<section class="public-section contact-page">
  <header class="public-page-header">
    <h2 class="public-page-title mb-4">Contato</h2>
  </header>

  <div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-8">
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <p class="mb-2">Para entrar em contato comigo, basta preencher o formulário.</p>
          <p class="text-muted mb-4">Respondo o mais breve possível!</p>

        <form (ngSubmit)="submitForm()" novalidate [formGroup]="formContato">
          <!-- Email -->
          <div class="mb-3">
            <label for="emailFrom" class="form-label">Seu e-mail</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-envelope-fill"></i></span>
              <input type="email" id="emailFrom" class="form-control" formControlName="emailFrom"
                placeholder="nome@exemplo.com" [ngClass]="{'is-invalid': submitted && f.emailFrom.errors}">
              </div>
              @if (submitted && f.emailFrom.errors) {
                <div class="invalid-feedback d-block">
                  @if (f.emailFrom.errors.required) {
                    <span>Email é obrigatório.</span>
                  }
                  @if (f.emailFrom.errors.pattern) {
                    <span>Por favor, informe um email válido.</span>
                  }
                </div>
              }
            </div>

            <!-- Assunto -->
            <div class="mb-3">
              <label for="assunto" class="form-label">Assunto</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-chat-left-dots-fill"></i></span>
                <input type="text" id="assunto" class="form-control" formControlName="assunto"
                  [ngClass]="{'is-invalid': submitted && f.assunto.errors}">
                </div>
                @if (submitted && f.assunto.errors) {
                  <div class="invalid-feedback d-block">
                    @if (f.assunto.errors.required) {
                      <span>Assunto é obrigatório.</span>
                    }
                  </div>
                }
              </div>

              <!-- Mensagem -->
              <div class="mb-3">
                <label for="mensagem" class="form-label">Mensagem</label>
                <textarea id="mensagem" class="form-control" formControlName="mensagem" rows="5"
                placeholder="Digite sua mensagem aqui..." [ngClass]="{'is-invalid': submitted && f.mensagem.errors}"></textarea>
                @if (submitted && f.mensagem.errors) {
                  <div class="invalid-feedback d-block">
                    @if (f.mensagem.errors.required) {
                      <span>Mensagem é obrigatória.</span>
                    }
                  </div>
                }
              </div>

              <!-- Botões -->
              <div class="mt-4">
                <button type="submit" class="btn btn-primary me-2" [disabled]="loading">
                  <i class="bi" [ngClass]="loading ? 'fa fa-spinner spinner-icon' : 'bi-send-fill'" class="me-1"></i>
                  {{ loading ? 'Enviando...' : 'Enviar' }}
                </button>
                <button type="reset" class="btn btn-outline-secondary">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </section>